"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/TeamPage/KeywordsTab/Preview.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _SmsPreview = require('web/components/SmsPreview');
var _components = require('web/screens/Directory/TeamPage/components');

// The phone previews on the Keywords tab. Patients read these lines, so the
// welcome line comes from welcomeLine, as in the real first text.










 const FirstText = ({ line, stopLine, isLineFocused, slot }) => (
  _react2.default.createElement(_SmsPreview.SmsBubble, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 20}}
    , _react2.default.createElement('span', { className: "team-page--keywords--preview-faded", __self: this, __source: {fileName: _jsxFileName, lineNumber: 21}}, "…your first text."  )
    , ' '
    ,  line && (
      _react2.default.createElement('mark', {
        className: _classBuilder2.default.call(void 0, 'team-page--keywords--preview-line', isLineFocused && 'team-page--keywords--preview-line--focus'),
        'data-testid': "keywords-welcome-line", __self: this, __source: {fileName: _jsxFileName, lineNumber: 24}}

        ,  line 
      )
    )
    ,  !line && slot && _react2.default.createElement('span', { className: "team-page--keywords--preview-slot", __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}},  slot ) 
    , ' ',  stopLine 
  )
); exports.FirstText = FirstText






 const Phone = ({ phone, children }) => (
  _react2.default.createElement(_SmsPreview.SmsPhone, { from: phone ? `Text message from ${phone}` : 'Text message', isThread: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}}
    ,  children 
  )
); exports.Phone = Phone






// The family texting the keyword and the reply coming back.
 const Exchange = ({ keyword, reply }) => (
  _react2.default.createElement(_react2.default.Fragment, null
    , _react2.default.createElement(_SmsPreview.SmsBubble, { side: "patient", 'data-testid': "keyword-preview-text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}
      ,  keyword || _react2.default.createElement('span', { className: "team-page--keywords--preview-faded", __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}, "KEYWORD") 
    )
    , _react2.default.createElement(_components.ReplyTag, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 58}}, "Keyword reply" )
    , _react2.default.createElement(_SmsPreview.SmsBubble, { 'data-testid': "keyword-preview-reply", __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}
      ,  reply || _react2.default.createElement('span', { className: "team-page--keywords--preview-faded", __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}, "Your reply" ) 
    )
  )
); exports.Exchange = Exchange
